import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {MailHistoService} from "../../../../core/services/entities/mail-histo.service";
import {MailHistoDTO} from "../../../../core/dtos/mail-histo-dto";
import {Subscription} from "rxjs";
import {UtilsService} from "../../../../core/utils/utils.service";
import {EmailContextEnum} from "../../../../core/dtos/email/email-context-enum";
import {EmailHistoFilters} from "../../../../core/dtos/email/email-histo-filters";

@Component({
  selector: 'yo-email-histo-button',
  templateUrl: './email-histo-button.component.html',
  styleUrls: ['./email-histo-button.component.scss']
})
export class EmailHistoButtonComponent implements OnInit, OnDestroy {

  /**
   * @deprecated
   */
  @Input() code: string;

  @Input() context: EmailContextEnum;

  @Input() entityId: number;

  @Input() emailHisto: MailHistoDTO;

  @Output() onMailHistoRetrieve: EventEmitter<MailHistoDTO> = new EventEmitter<MailHistoDTO>();

  private emailHistoRequestSub: Subscription;

  constructor(public emailHistoSvc: MailHistoService,
              private utilsSvc: UtilsService) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.utilsSvc.unsubscribe(this.emailHistoRequestSub);
  }

  openHistoriqueMails = () => {
    let filters: EmailHistoFilters = {
      extraInfos: this.code,
      context: this.context,
      entityId: this.entityId,
      token: null
    }

    this.emailHistoSvc.openEmailHistoDialog(filters, (result: MailHistoDTO) => {
      if (result) {
        this.emailHisto = result;
        this.onMailHistoRetrieve.next(result);
      }
    })
  }

}
